export default "__VITE_ASSET__4d3339c2__"